import { selector } from 'recoil';
import useHttpRequest from '../../components/api/HttpRequest';

const ClientSideConfigSelector = selector({
  key: 'clientSideConfigSelector',
  get: async () => {
    try {
      const httpRequest = useHttpRequest();
      const result = await httpRequest.send('/config?filter=live.claimReward');
      // eslint-disable-next-line no-console
      console.log('config result', result);
      return result;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error fetching config', err);
      return {
        err: {},
      };
    }
  },
});

export default ClientSideConfigSelector;
